import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Stack extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)
    this.index = 0
    this.progress = 0

    this.ref = {
        stack: "",
        img:  []
    }

  }


  mount() {
        

        $(this.ref.stack).on('click', (e)=>{
            
            this.changeImg()
            
        })


        ScrollTrigger.create({
            trigger: this.element,
            start:  "center bottom",
            end: "center top",
            onUpdate: (self) => {
                this.progress != self.progress.toFixed(1) && this.changeImg()
                this.progress = self.progress.toFixed(1)
            }
        });
  }

  changeImg(){
        $(this.ref.img[this.index]).removeClass('family__img--top')
        this.index = gsap.utils.wrap(0, this.ref.img.length, ++this.index)
        $(this.ref.img[this.index]).addClass('family__img--top')
  }


  unmount() {

  }





}

module.exports = Stack
